import '../../@types/index';
import 'core-js/actual/object';
import 'core-js/actual/array';
import 'whatwg-fetch';
// @ts-ignore
import partionSwitchHtml from '!!raw-loader!./partitionSwitch.html';
import { loadScript } from './loader';

/** DEBUG 加载的文件 */
const currentScript = document.currentScript as HTMLScriptElement | null;
let hash = '';
if (currentScript) {
    // let src = currentScript.getAttribute('src');
    let src = currentScript.src;
    if (!src) hash = String(Math.floor(new Date().getTime() / 86400000) * 86400);
    else hash = encodeURIComponent(src.match(/([^/#]+)$/)?.[1] ?? '');
    console.info(`[Act] 当前加载的脚本文件：src = ${src}, hash = ${hash}`);
}

/** 加载 MILO 库 */
export async function loadMilo() {
    /** 加载 MILO 库 */
    // if (typeof $ === 'undefined') document.writeln(`<script src="https://events.honorofkings.com/act/milo-next/jquery-1.11.3.min.js?__t=${hash}"></script>`);
    // if (typeof Milo === 'undefined') document.writeln(`<script src="https://events.honorofkings.com/act/milo-next/milo.min.js?__t=${hash}"></script>`);
    // if (typeof Milo === 'undefined') document.writeln(`<script src="js/milo.js?__t=${hash}"></script>`);
    if (typeof $ === 'undefined') {
        await loadScript(`https://events.honorofkings.com/act/milo-next/jquery-1.11.3.min.js?__t=${hash}`, () => {});
        console.info('[Act] jQuery 加载完毕');
    }
    if (typeof Milo === 'undefined') {
        await loadScript(`js/milo.js?__t=${hash}`, () => {});
        console.info('[Act] Milo 加载完毕');
    }
}

/** 是否是本地开发环境 */
export function isLocalEnv(): boolean {
    // return (window.$wujie?.location ?? location).hostname === 'localhost' || (window.$wujie?.location ?? location).hostname === '127.0.0.1';
    return /^localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test((window.$wujie?.location ?? location).hostname);
}

/** 是否是测试环境 */
export function isTestEnv(): boolean {
    return (window.$wujie?.location ?? location).hostname === 'events-test-1310788819.cos-website.ap-singapore.myqcloud.com';
}

/** 是否是正式环境 */
export function isProductEnv(): boolean {
    return (window.$wujie?.location ?? location).hostname === 'events.iegcom.com';
}

export enum Debug {
    AUTO = 'auto',
    TRUE = 1,
    FALSE = 0,
}

/** 开启 eruda 调试工具 */
export function enableDebug(ok: Debug = Debug.AUTO): void {
    if (typeof eruda !== 'undefined') return; // 已加载过 eruda
    if (ok === Debug.FALSE) return;
    if (ok === Debug.AUTO) {
        if (isProductEnv() && getQueryParam('__test') !== '1') return; // 生产环境不允许自动开启 DEBUG
        // 自动开启 DEBUG
    }
    // 开启 DEBUG
    document.writeln('<script src="https://game.gtimg.cn/images/js/milo-utils/eruda/3.0.0/eruda.js"></script><script>eruda.init();</script>');
}

function parseAreaPartition(str: string) {
    let [area, partition]: [number | string, number | string] = str?.split(',') as any;
    area = Number(area);
    partition = Number(partition);
    if (!area || isNaN(area) || area < 0) area = isProductEnv() ? 8 : 88;
    if (!partition || isNaN(partition) || partition < 0) partition = isProductEnv() ? 108011 : 108001;
    return [area, partition];
}
// let defaultArea = isProductEnv() ? 8 : 88;
// let defaultPartition = isProductEnv() ? 108011 : 108001;
let [defaultArea, defaultPartition] = parseAreaPartition('0');

/** 开启区服切换调试工具 */
export function enablePartitionSwitch(onChange?: () => any) {
    const hostID = '__host_partition_switch';
    if (document.getElementById(hostID)) return;

    let curAreaPartition = localStorage.getItem('__default_area_partition__');
    if (!curAreaPartition) curAreaPartition = `${defaultArea},${defaultPartition}`;
    else [defaultArea, defaultPartition] = parseAreaPartition(curAreaPartition);
    console.info('[Act] 当前默认 area =', defaultArea, ', partition =', defaultPartition);
    const partitionList = {
        '0': '自动',
        '8,108011': '正式服',
        '88,108001': '新加坡研发测试1服',
        '88,108004': '新加坡研发测试2服',
        '88,108003': '主干服',
    };
    const options: string[] = [];
    Object.entries(partitionList).every(([k, v]) => {
        options.push(`<option value="${k}"${k === curAreaPartition ? ' selected' : ''}>${v}</option>`);
        return true;
    });

    const hostDiv = document.createElement('div');
    hostDiv.id = hostID;
    document.body.append(hostDiv);

    const shadow = hostDiv.attachShadow({ mode: 'open' });
    const content = new Function('options', 'return `' + partionSwitchHtml + '`')(options) as string;
    // console.debug('[Act][enablePartitionSwitch]', content);
    const dom = document.createElement('html')!;
    dom.innerHTML = content;
    shadow.appendChild(dom);

    shadow.querySelector('select')?.addEventListener('change', function () {
        console.info('[Act] 切换默认 area 和 partition', this.value);
        [defaultArea, defaultPartition] = parseAreaPartition(this.value);
        console.info('[Act] 默认 area =', defaultArea, ', partition =', defaultPartition);
        localStorage.setItem('__default_area_partition__', `${defaultArea},${defaultPartition}`);
        setTimeout(() => {
            onChange?.();
            // (window.$wujie?.location ?? location).reload();
        }, 10);
    });
}

/** PHP explode 的 JavaScript 实现：使用一个字符串分割另一个字符串 */
export function explode(sep: string, str: string, limit?: number): string[] {
    if (!str) return [];
    const arr = str.split(sep);
    if (!limit || limit <= 0 || arr.length <= limit) return arr;
    const tmp = arr.splice(0, limit - 1);
    tmp.push(arr.join(sep));
    return tmp;
}

/** 获取指定的链接参数 */
export function getQueryParam(name: string): string | undefined {
    const reg = new RegExp(`\\b${name}=([^&#?]*)`);
    const matched = (window.$wujie?.location ?? location).search?.match(reg);
    // console.log(matched);
    if (!matched) return undefined;
    return matched[1];
}

/** 获取全部的链接参数 */
export function getQueryParams(...names: string[]) {
    const out: { [n: string]: string | undefined } = {};
    for (const n of names) {
        out[n] = getQueryParam(n);
    }
    return out;
}

export function getAllQueryParams(url?: string): { [k: string]: string } {
    const out: { [k: string]: string } = {};
    if (!url) url = (window.$wujie?.location ?? location).search;
    if (!url) return out;
    const [, queryString] = explode('?', url, 2);
    if (!queryString) return out;
    const arr = queryString.split('&');
    for (const s of arr) {
        let [k, v] = explode('=', s, 2);
        if (v == null) continue;
        k = decodeURIComponent(k);
        v = decodeURIComponent(v);
        out[k] = v;
    }
    return out;
}

/** 构造链接参数 */
export function buildQueryParams(params: { [k: string]: string | number | boolean | null | undefined }): string {
    const arr: string[] = [];
    for (const [k, v] of Object.entries(params)) {
        if (v == null) continue;
        arr.push(k + '=' + encodeURIComponent(v));
    }
    return arr.join('&');
}

/** 解码 JSON 字符串，失败时不抛出异常，返回 undefined */
export function json_decode(str: string): any {
    if (!str) return undefined;
    try {
        return new Function(`return (${str});`)();
    } catch (e) {
        console.error('[Act] json_decode exception:', e);
        return undefined;
    }
}

export function prefixNumber(num: number, prefix = '0'): string {
    if (num > 9) return String(num);
    return prefix + num;
}

export function formatDate(format: string, date?: Date | number): string {
    if (!date) date = new Date();
    else if (!(date instanceof Date)) date = new Date(date);
    const arr: (string | number)[] = [];
    for (let i = 0; i < format.length; i++) {
        const s = format[i];
        if (s === 'Y') arr.push(date.getFullYear());
        else if (s === 'm') arr.push(prefixNumber(date.getMonth() + 1));
        else if (s === 'd') arr.push(prefixNumber(date.getDate()));
        else if (s === 'H') arr.push(prefixNumber(date.getHours()));
        else if (s === 'i') arr.push(prefixNumber(date.getMinutes()));
        else if (s === 's') arr.push(prefixNumber(date.getSeconds()));
        else arr.push(s);
    }
    return arr.join('');
}

export declare interface UserInfo {
    sOpenId: string;
    sRoleId: string;
    sArea: number;
    os: number;
    sPartition: number;
    channelid: number;
    encodeparam: string;
    nickName: string;
    headUrl: string;
    langStr: string;
    langNum: number;
}

/** 传入的值是否全为 null 或 undefined 或 空字符串 */
export function isEmpty(...vals: any): boolean {
    let ok = vals.length < 1; // 不传参为 true，其它情况初始化为 false
    for (const v of vals) {
        ok = v == null || v === '';
        if (!ok) break;
    }
    console.debug('[Act][isEmpty]', ok, vals);
    return ok;
}

export function requireParams(obj: any, ...names: any[]): boolean {
    if (!obj) return false;
    let ok = true;
    for (const n of names) {
        if (obj[n] == null || obj[n] === '') {
            ok = false;
            console.warn(`[Act] requireParams: ${n} 为空`, obj);
            break;
        }
    }
    return ok;
}

/** 判断页面是否处于综合站 WUJIE 中 */
export function isInWujie(): boolean {
    // @ts-ignore
    return window.__POWERED_BY_WUJIE__ && !!window.$wujie.props.login;
}

/** 判断是否在游戏内浏览器打开 */
export function isIntlSDK(userInfo?: UserInfo): boolean {
    const params = getAllQueryParams();
    if (!requireParams(params, 'sopenId', 'sRoleId', 'sArea', 'os', 'sPartition', 'channelid', 'encodeparam')) return false;
    if (userInfo) {
        params.sOpenId = params.sopenId;
        Object.assign(userInfo, params);
    }
    return true;
}

export function isMobile() {
    // 常见的移动浏览器User-Agent中的关键词
    const reg = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Opera Mobi|Windows Phone/i;
    // @ts-ignore 获取用户代理字符串
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    return reg.test(userAgent);
}

/** 判断当前 UA 是否是 iOS */
export function isIOS(): boolean {
    return /\biPhone|\biPad|iPod|\bMac/i.test(navigator.userAgent);
}

/** 是否是三星 */
export function isSamsung(): boolean {
    return /SAMSUNG|SGH-[I|N|T]|GT-[I|P|N]|SM-[N|P|T|Z|G]|SHV-E|SCH-[I|J|R|S]|SPH-L/i.test(navigator.userAgent);
}

/** 是否是 Instagram */
export function isInstagram(): boolean {
    return /\bInstagram/.test(navigator.userAgent);
}

/** 是否是 Facebook */
export function isFacebook(): boolean {
    return /\bFBAN|\bFBAV|\bFBIOS/.test(navigator.userAgent);
}

/** 是否是 微信 */
export function isWeChat() {
    return /MicroMessenger/gi.test(navigator.userAgent);
}

/** 是否是 QQ */
export function isQQ() {
    return /QQ/gi.test(navigator.userAgent);
}

/** 使用 JSONP 的方式实现跨域请求 */
export function corsGetJson(data: { [key: string]: any }, onSuccess: ((data: any) => any) | undefined = undefined, onFailed: ((err: any) => any) | undefined = undefined) {
    const queryString = buildQueryParams(data);
    const dom = document.createElement('script') as HTMLScriptElement;

    let timer: any;
    const cancelTimer = () => {
        // @ts-ignore
        delete window[jsonp];
        if (!timer) return;
        clearTimeout(timer);
        timer = undefined;
    };

    const jsonp = `__${new Date().getTime()}_${Math.random()}_cb`.replace(/[^\w_]/g, '');
    const callback = (data: any) => {
        cancelTimer();
        console.info('[Act] corsGetJson:', data);

        if (!data) {
            onFailed?.('empty response');
            return;
        }

        try {
            onSuccess?.(data.jData?.jData?.jData || data.jData?.jData || data.jData || data);
        } catch (err) {
            onFailed?.(err);
        }

        // @ts-ignore
        delete window[jsonp];
    };
    // @ts-ignore
    window[jsonp] = callback;
    console.info('[Act] corsGetJson: jsonp =', jsonp);

    dom.async = true;
    // dom.type = 'text/script';
    dom.src = `//webide-game.iegcom.com/ide${getQueryParam('__test') === '1' ? 'Test' : ''}/?${queryString}&jsonp=${jsonp}`;
    dom.onload = () => {
        console.info('[Act] corsGetJson: 文件已加载，准备执行回调', jsonp);
        setTimeout(() => {
            // @ts-ignore
            if (window[jsonp]) {
                console.error('[Act] corsGetJson: JSONP 回调执行失败:', jsonp);
                return;
            }
            console.info('[Act] corsGetJson: JSONP 回调已执行:', jsonp);
        }, 10);
    };
    dom.onabort = () => {
        cancelTimer();
        onFailed?.('abort');
    };
    document.body.appendChild(dom);

    timer = setTimeout(() => {
        cancelTimer();
        console.error('[Act] corsGetJson: 请求超时');
        onFailed?.('timeout');
    }, 5000);
}

/** 返回一个在指定时间 interval （秒，默认3秒）内只能调用一次 fn 的函数 */
export function onceCall(fn: (...args: any[]) => any, interval: number = 3) {
    let timer: any = undefined;
    return (...args: any[]) => {
        if (timer) {
            console.debug(`[Act][onceCall] ${interval} 秒只能调用一次`);
            return;
        }
        timer = setTimeout(() => {
            clearTimeout(timer);
            timer = undefined;
        }, interval * 1000);
        return fn(...args);
    };
}

/** 启动一个定时器，每隔一定时间 tick 执行一次回调函数，如果回调函数返回 false 则表示提前终止定时器，timeout 参数表示超时 */
export function startTimer(onTick: (isTimeout: boolean, now: number, startTime: number) => any, timeout: number = 5000, tick: number = 100) {
    timeout = Math.ceil(timeout);
    const startTime = new Date().getTime(); // 启动时间
    const targetTime = startTime + timeout; // 超时时间
    const cb = () => {
        const now = new Date().getTime();
        const isTimeout = now >= targetTime; // 是否超时
        if (isTimeout) console.warn(`[Act][startTimer] 定时器超时[timeout = ${timeout}]: ${now} - ${startTime} =`, now - startTime, (now - startTime) / 1000, '秒');
        if (onTick?.(isTimeout, now, startTime) === false) return; // 显示返回 false 表示提前终止定时器
        if (!isTimeout) setTimeout(cb, tick); // 还未等待超时，等待下一次 tick 回调
    };
    setTimeout(cb, tick);
}

export enum DeepLinkType {
    GOTO_GAME = 0,
    GOTO_PANDORA = 1,
    GOTO_MSDK = 2,
    GOTO_X5 = 4,
}

/** 跳转 DeepLink 链接
 * @param type 拉起游戏的行为：0 只拉起游戏、1 拉起到潘多拉、2 MSDK、3 X5 浏览器
 * @param data Deeplink 链接参数：只是拉起游戏不需要传值或传空，拉起潘多拉传递一个 object 对象，拉起 MSDK 或 X5 浏览器传递一个 URL 链接
 * @param success 拉起成功时需要执行的回调函数
 * @param failed 拉起失败时需要跳转的失败页面，或者需要执行的回调函数
 */
export function gotoGame(
    type: DeepLinkType,
    data: undefined | null | string | { [key: string]: any },
    success: undefined | null | (() => any),
    failed: undefined | null | string | (() => any) = undefined,
) {
    let url = '';
    if (type === DeepLinkType.GOTO_GAME) {
        console.debug('[Act][DeepLink]', '拉起游戏');
        url = 'pbpsdkhok://?gamedata=JUNMFORM_Pandora';
    } else if (type === DeepLinkType.GOTO_PANDORA) {
        const str = typeof data !== 'string' ? JSON.stringify(data) : data;
        console.debug('[Act][DeepLink]', `拉起游戏跳转到潘多拉 json = ${str}`);
        url = 'pbpsdkhok://?gamedata=JUNMFORM_Pandora_' + btoa(str);
    } else if (type === DeepLinkType.GOTO_MSDK) {
        console.debug('[Act][DeepLink]', `拉起游戏 MSDK 页面链接：${data}`);
        url = 'pbpsdkhok://?gamedata=JUMPMSDK_' + encodeURIComponent(data as string);
    } else if (type === DeepLinkType.GOTO_X5) {
        console.debug('[Act][DeepLink]', `拉起游戏 X5 页面链接：${data}`);
        url = 'pbpsdkhok://?gamedata=JUMPX5_' + encodeURIComponent(data as string);
    } else {
        throw 'Invalid DeepLink Type: ' + type;
    }

    setTimeout(() => {
        console.info('[Act][DeepLink]', `拉起游戏 DeepLink = ${url}`);
        (window.$wujie?.location ?? location).href = url;
    }, 10);

    let leftCount: any = 3;
    let timer = setInterval(() => {
        leftCount! -= 1;
        if (leftCount! > 0) return;
        leftCount = null;
        clearInterval(timer);
        timer = undefined as any;

        if (document.hidden || document.visibilityState === 'hidden') {
            console.info('[Act][DeepLink]', '已成功拉起游戏~');
            gtag('event', 'deeplink_success', { event_label: 'goto game' });
            success?.();
        } else if (failed) {
            console.info('[Act][DeepLink]', '无法在规定时间内拉起游戏~');
            gtag('event', 'deeplink_failed', { event_label: 'goto game' });
            if (typeof failed === 'function') failed();
            else (window.$wujie?.location ?? location).href = failed as string;
        }
    }, 1000);
}
// 初始化下载链接
export const downloadUrls: { android: string; ios: string; [k: string]: string } = {
    android: 'https://www.honorofkings.com/download/HonorOfKings_App_Android_9.4.1.2_r1828274_4101_rw.apk', // 使用官网包下载
    // android: 'https://play.google.com/store/apps/details?id=com.levelinfinite.sgameGlobal', // 使用应用商店包下载
    ios: 'https://apps.apple.com/app/id1619254071', // 使用应用商店包下载
    // samsung: 'https://apps.samsung.com/appquery/preOrderDetail.as?contentld=000006644533', // 使用三星应用商店包下载
};

/** 注册 Deeplink 按钮，点击按钮时拉起游戏并跳转到潘多拉，失败的默认行为是跳转应用商店（Android现在是直接下载官网包），可以在 onFailed 回调中修改默认行为：返回 false 表示不执行后续跳转，返回字符串调试跳转到指定的链接 */
export function registerDeeplinkButton(selectors: string, data: any, onSuccess?: () => any, onFailed?: (url: string) => any) {
    const doms = document.querySelectorAll(selectors);
    if (!doms.length) return;

    // 拉起游戏客户端成功后的回调函数
    const cbSuccess = () => {
        // 已成功拉起游戏客户端
        console.info('[Act] 成功拉起游戏客户端了~');
        onSuccess?.();
    };
    // 拉起游戏客户端失败的回调函数
    const cbFailed = () => {
        // 没能在 3 秒内拉起客户端，则直接跳转到应用商店下载页面
        console.warn('[Act] 无法拉起游戏客户端或者等待超时~');
        let url = '';
        // ios 直接跳转到应用上带你
        if (isIOS()) url = downloadUrls.ios;
        // samsung 直接跳转到三星应用商店
        else if (downloadUrls.samsung && isSamsung()) url = downloadUrls.samsung;
        // Android 统一使用官网包下载
        else url = downloadUrls.android;

        const ret = onFailed?.(url); // 返回 false 表示不跳转，返回字符串表示跳转到指定链接
        // eslint-disable-next-line prettier/prettier
        if (ret === false) return; // 返回 false 表示不跳转
        else if (ret && typeof ret === 'string') url = ret; // 返回字符串表示跳转到指定链接

        gtag('event', 'deeplink_failed_to_download', { event_label: isIOS() ? 'ios' : 'android' });
        console.warn('[Act] 似乎未能打开游戏，前往下载：', url);
        (window.$wujie?.location ?? location).href = url;
    };

    for (const dom of Array.from(doms)) {
        dom.addEventListener('click', () => {
            gtag('event', 'deeplink_click', { event_label: 'deeplink_click' });
            if (isWeChat() || (isIOS() && (isFacebook() || isInstagram()))) {
                // ios fb/ins 不支持 Deeplink，直接触发失败回调
                console.warn('[Act] iOS fb/ins Deeplink 不成效~');
                gtag('event', 'deeplink_failed', { event_label: 'ios fb/ins' });
                cbFailed();
            } else {
                console.info('[Act][gotoPandora] 正在尝试拉起潘多拉……');
                gotoGame(DeepLinkType.GOTO_PANDORA, data, cbSuccess, cbFailed);
            }
        });
    }
}

let currMiloActId: any = undefined;
let miloLocking: boolean = false;
/** 发送 Milo 请求 */
export async function miloEmit(
    actId: string,
    flowId: string,
    sData?: Milo.EmitParams['sData'],
    onSuccess?: (data: any, ret: any) => any,
    onFailed?: Milo.EmitParams['fail'],
    loading: boolean = false,
): Promise<any | void> {
    if (!window.Milo) {
        console.error(`[Act][initMilo] 还未加载 Milo 库，请求在 HTML 页面引入以下代码
<script src="https://events.honorofkings.com/act/milo-next/jquery-1.11.3.min.js"></script>
<script src="https://events.honorofkings.com/act/milo-next/milo.min.js"></script>`);
        return;
    }
    if (currMiloActId != actId) {
        if (miloLocking) {
            // 切换活动时，先等待上一个活动的发出请求
            await new Promise((resolve) => {
                let timer = setInterval(() => {
                    if (!miloLocking) {
                        resolve(void 0);
                        clearInterval(timer);
                        timer = undefined as any;
                    }
                }, 100);
            });
        }
        let idePrefix = 'https://webide-game.iegcom.com/ide'; // 正式环境
        // eslint-disable-next-line prettier/prettier
        if (isLocalEnv()) idePrefix = '/ideTest'; // 本地开发环境
        else if (isTestEnv()) idePrefix = 'https://webide-game.iegcom.com/ideTest'; // 测试环境
        Milo.setCommonConfig({
            needPromiseCallback: false,
            activityApi: `${idePrefix}/page/${actId}`,
            ideApi: `${idePrefix}/`,
        });
        currMiloActId = actId;
        console.debug('[ Milo setCommonConfig ] 设置公共配置：', { idePrefix, actId });
    }
    miloLocking = true;
    // 海外HOK请求必须带上 instanceid
    if (!sData) sData = {} as any;
    if (!sData!.instanceid) {
        const instanceid = +actId.split('_')[0];
        sData!.instanceid = instanceid;
    }
    /**
     * 正式 area = 8,  partiton=108011
     * 测试 area = 88, partiton具体看是哪个测试服，比如 新加坡研发测试服是108001， 新加坡研发测试2服是 108004，主干服貌似是108003
     * */
    if (!sData!.gameid) sData!.gameid = 29134;
    if (!sData!.sArea) sData!.sArea = defaultArea;
    if (!sData!.sPlatId) sData!.sPlatId = isIOS() ? 0 : 1;
    if (!sData!.sPartition) sData!.sPartition = defaultPartition;
    await loadMilo();
    return new Promise((resolve) => {
        Milo.emit({
            actId,
            token: flowId,
            loading,
            sData,
            success(ret) {
                // miloLocking = false;
                const iRet = ret.details?.jData?.iRet ?? ret.details?.iRet ?? ret.iRet;
                const sMsg = ret.details?.jData?.sMsg ?? ret.details?.sMsg ?? ret.sMsg;
                if (iRet != 0) {
                    resolve(void 0);
                    console.error('[Milo][emit] 请求失败：', { iRet, sMsg }, ret);
                    return;
                }
                const data = ret.details ?? ret.data ?? ret;
                console.debug('[Milo][emit] 请求成功：', { iRet, sMsg, data }, ret);
                onSuccess?.(data, ret);
                resolve(data);
            },
            fail(err) {
                // miloLocking = false;
                console.error('[Milo][emit] 请求失败：', err);
                onFailed?.(err);
                resolve(void 0);
            },
        });
        // 发出请求后，解锁 Milo.emit
        setTimeout(() => (miloLocking = false), 0);
    });
}

/** 拉取活动配置信息 */
export async function getActivityConfig(actName?: string, sData?: { [k: string]: any }, onSuccess?: (data: any) => any, onFailed?: (err: any, ...rest: any[]) => any) {
    if (!actName) actName = (window.$wujie?.location ?? location).pathname.match(/(?:act|cp)\/([^/]+)/)?.[1];
    miloEmit(
        '3000644_X3IFJY', // 公用请求节点，拉取活动配置信息
        'Ku69kx',
        { ...(sData || {}), act: actName }, // act 参数指定需要拉取的活动配置
        (ret) => {
            const data = ret.jData?.jData;
            if (!data) {
                console.warn('[Act] 没有拉取到配置信息:', ret);
                onFailed?.('没有拉取到配置信息', data); // 没有获取到活动配置信息
                return;
            }
            console.info('[Act] 拉取到活动配置信息:', data);
            // 通用下载链接配置信息
            if (data.download) {
                for (const [k, v] of Object.entries(data.download)) downloadUrls[k] = v as string;
                console.info('[Act] 更新下载链接配置:', downloadUrls);
            }
            // 检查活动自定义下载链接配置
            if (data.config) {
                let useActDownload = false;
                for (const [k, v] of Object.entries(data.config)) {
                    const matched = k.match(/^download\.(.+)$/);
                    if (!matched) continue;
                    downloadUrls[matched[1]] = v as string;
                    useActDownload = true;
                }
                if (useActDownload) console.info('[Act] 使用活动自定义下载链接配置:', downloadUrls);
            }
            onSuccess?.(data);
        },
        onFailed, // 拉取活动配置信息失败: 直接初始化页面
    );
}
